import { Button, Stack, Typography } from '@mui/material';
import { Tab } from '../types';

type HelperTextProps = {
  onCopySelection?: () => void;
  tab: Tab;
};

export const HelperText: React.FC<HelperTextProps> = ({
  tab,
  onCopySelection,
}) => {
  if (tab === 'conventionalAlternative') {
    return <ConventionalHelperText />;
  }

  if (tab === 'reducedCarbonAlternative') {
    return <ReducedCarbonHelperText onCopySelection={onCopySelection} />;
  }

  if (tab === 'zeroCarbonAlternative') {
    return <ZeroCarbonHelperText onCopySelection={onCopySelection} />;
  }
};

type Props = {
  onCopySelection?: () => void;
};

const ConventionalHelperText: React.FC = () => {
  return (
    <Stack px={4} spacing={4}>
      <Typography>
        Conventional alternative builds are what you would traditionally use
        without consideration of carbon impact.
      </Typography>
      <Typography>Start adding components to create your build.</Typography>
    </Stack>
  );
};

const ReducedCarbonHelperText: React.FC<Props> = ({ onCopySelection }) => {
  return (
    <Stack px={4} spacing={4}>
      <Typography>
        Low Carbon builds do not use any components that consume natural gas.
      </Typography>
      <Typography>Start adding components to create your build</Typography>
      <Typography>
        Try to keep your Energy Demand low to maximize your decreased carbon
        impact.
      </Typography>
      <Typography>
        Note: You may pull in Low Carbon compatible elements from your previous
        build.
      </Typography>
      <Stack px={16}>
        <Button color={'success'} variant='contained' onClick={onCopySelection}>
          RE-USE PREVIOUS BUILD
        </Button>
      </Stack>
    </Stack>
  );
};

const ZeroCarbonHelperText: React.FC<Props> = ({ onCopySelection }) => {
  return (
    <Stack px={4} spacing={4}>
      <Typography>
        Zero Carbon builds do not use any components that consume natural gas
        and only use low Energy Demand components.{' '}
      </Typography>
      <Typography> Start adding components to create your build</Typography>
      <Typography>
        Note: You may pull in Zero Carbon compatible elements from your previous
        builds.
      </Typography>
      <Stack px={16}>
        <Button color={'success'} variant='contained' onClick={onCopySelection}>
          RE-USE PREVIOUS BUILD
        </Button>
      </Stack>{' '}
    </Stack>
  );
};
